'use client'

import { usePathname } from 'next/navigation'
import { t, citiesPath } from '../lib/i18n'

/**
 * The footer, in the language of the page it is on.
 *
 * A client component for the same reason the header is one: it is rendered by the ROOT layout, and
 * a root layout cannot know the locale without calling headers(), which would make every one of the
 * 672 static pages render on demand. usePathname is free and always correct.
 */
export default function SiteFooter() {
  const pathname = usePathname()
  const locale = pathname === '/en' || pathname?.startsWith('/en/') ? 'en' : 'es'
  const T = t(locale)
  const en = locale === 'en'

  return (
    <footer className="siteFooter">
      <div className="siteFooter__inner">
        <nav aria-label={en ? 'Footer' : 'Pie de página'}>
          <a href={citiesPath(locale)}>{T.cities}</a>
          <a href={en ? '/' : '/en'}>{T.otherLang}</a>
          <a href="/anunciate">{en ? 'Advertise' : 'Anúnciate'}</a>
          <a href="/privacidad">{en ? 'Privacy' : 'Privacidad'}</a>
          <a href="/cookies">Cookies</a>
          <a href="/aviso-legal">{en ? 'Legal notice' : 'Aviso legal'}</a>
        </nav>
        {/* The dataset is OpenStreetMap under ODbL. The credit is owed, and it is not optional —
            it belongs on every page, not only on the map. */}
        <span className="siteFooter__legal">
          DogParks España · {en ? 'data' : 'datos'}{' '}
          <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">
            © OpenStreetMap
          </a>
        </span>
      </div>
    </footer>
  )
}
